import { SVLoader } from '@/components/core';
import CustomersForm from '@/components/customers/CustomersForm';
import DefaultLayout from '@/components/layouts/DefaultLayout';
import { ROUTES } from '@/constants/routes';
import { useGetCustomerDetails } from '@/hooks/requests/useCustomers';
import { Card, Typography } from '@mui/material';
import { useNavigate, useParams } from 'react-router-dom';

export default function CustomersEditPage() {
  const { uuid = '' } = useParams();
  const navigate = useNavigate();
  const { customerDetails, isCustomerDetailsPending } =
    useGetCustomerDetails(uuid);

  if (isCustomerDetailsPending) {
    return (
      <DefaultLayout header="">
        <Card>
          <SVLoader />
        </Card>
      </DefaultLayout>
    );
  }

  if (!customerDetails) {
    return (
      <DefaultLayout header="">
        <Card>
          <Typography>
            Something went wrong retreiving the customer. Our team has been
            notified.
          </Typography>
        </Card>
      </DefaultLayout>
    );
  }
  const customerName = ` ${customerDetails.firstName} ${customerDetails.lastName}`;

  return (
    <DefaultLayout
      header={`Edit ${customerName}`}
      breadcrumb={[
        { label: 'Customers', href: ROUTES.CUSTOMERS },
        {
          label: customerName,
          href: `${ROUTES.CUSTOMERS}/${customerDetails.uuid}`,
        },
        { label: 'Edit', isActive: true },
      ]}>
      <CustomersForm
        isEdit
        defaultValues={{
          uuid,
          firstName: customerDetails.firstName,
          middleName: customerDetails.middleName,
          lastName: customerDetails.lastName,
          phone: customerDetails.phoneNumber,
          confirmPhone: customerDetails.phoneNumber,
          dob: customerDetails.dateOfBirth,
          email: customerDetails.email,
          confirmEmail: customerDetails.email,
          ssn: customerDetails.ssn,
          confirmSsn: customerDetails.ssn,
          company: customerDetails.company.uuid,
          advisors: customerDetails.advisors.map(advisor => advisor.uuid),
          currentAddress: {
            line1: customerDetails.address.line1,
            line2: customerDetails.address.line2,
            city: customerDetails.address.city,
            state: customerDetails.address.state,
            postalCode: customerDetails.address.postalCode,
          },
          sameMailingAddress: customerDetails.isMailingAddressSameCurrentAddr,
          mailingAddress: {
            line1: customerDetails.mailingAddress.line1,
            line2: customerDetails.mailingAddress.line2,
            city: customerDetails.mailingAddress.city,
            state: customerDetails.mailingAddress.state,
            postalCode: customerDetails.mailingAddress.postalCode,
          },
          min: customerDetails.minimumInitDeposit?.value.toString() || '0',
          max: customerDetails.maximumInitDeposit?.value.toString() || '0',
        }}
        onSuccess={(uuid: string) => navigate(`${ROUTES.CUSTOMERS}/${uuid}`)}
      />
    </DefaultLayout>
  );
}
